$(window).on('load resize', function () {
  if ($('.responsive-pagination')) {
    const paginationWidth = $('.responsive-pagination').width();
    if (paginationWidth < 738) {
      const len = $('.responsive-pagination .page-item').length;
      if (len > 8) {
        const index = $('.responsive-pagination .page-item.active').index();
        for (let i = 0; i < len; i++) {
          const isMore = $('.responsive-pagination .page-item').eq(i).hasClass('disabled');
          if ([1, index - 1, index, index + 1, len - 2].includes(i) || isMore) {
            continue;
          }
          $('.responsive-pagination .page-item').eq(i).addClass('d-none');
        }
      }
    } else {
      $('.responsive-pagination .page-item').removeClass('d-none');
    }
  }
});
